import { Row } from "react-bootstrap";

import LootLedgerHome from "../../../shared/components/shared/LootLedgerHome";
import ShopifyConnection from "./ShopifyConnection";

const ShopifyConnectionForActualUsers = () => {
  return (
    <>
      <LootLedgerHome>
        <ShopifyConnection isActualUser />
      </LootLedgerHome>
    </>
  );
};

export default ShopifyConnectionForActualUsers;
